// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3FKqq","col":"CardReaderDesc_col__zN61K","label":"CardReaderDesc_label__1HGqs"};